import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Col, Grid, Row} from 'react-bootstrap';
import { getPointsTypes } from '../../../../actions/points-types';
import PointsTypesList from './points-types-list';

class PointTypes extends Component {
  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(getPointsTypes());
  }

  render() {
    return (
      <Grid bsClass="container" fluid className="point-types">
        <Row>
          <Col md={12}>
            <PointsTypesList
              pointsTypes={this.props.pointsTypes}
              fetched={this.props.fetched}
              fetching={this.props.fetching}
            />
          </Col>
        </Row>
      </Grid>
    );
  }
}

const mapStateToProps = state => ({
  pointsTypes: state.pointsTypes.pointsTypes,
  fetching: state.pointsTypes.fetching,
  fetched: state.pointsTypes.fetched
});

export default connect(mapStateToProps)(PointTypes);



// WEBPACK FOOTER //
// ./src/components/admin/points-types/list/index.jsx